export enum FractionYesnoValueEnum { // TODO: yesno
  Yes = 'Yes',
  No = 'No'
}
